import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';

import Autocomplete from '@mui/material/Autocomplete'; 
import TextField from '@mui/material/TextField';




const AgenceAutocomplete = ({ value, onChange, required, autoFocus, label, placeholder, modeTri, size }) => {

    const [loading, setLoading] = React.useState(true);
    const [agences, setAgences] = React.useState([]);

    const [valeur, setValeur] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');

    // Fetch des infos au chargement du composant
    React.useEffect(() => {
        const fetchData = async () => {

            await axios('api/agences')
                .then(function (response) {
                            
                    let recues = response.data;

                    if (modeTri === 1) {
                        recues = recues.sort((a, b) => a.libelle > b.libelle);
                    }

                    setAgences(recues);

                    let agence = recues.find(x => x.code === value);
                    if (agence) {
                        setValeur(agence.code);
                        setInputValue(agence.code + ' - ' + agence.libelle);
                    }

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setLoading(false);
                });

        };


        if (loading) {
            fetchData();
        }

    }, [loading]);


    React.useEffect(() => {
        if (value) {
            setValeur(value);
            let agence = agences.find(x => x.code === value);
            if (agence) {
                setInputValue(agence.code + ' - ' + agence.libelle);
            }
            else {
                setInputValue('');
            }
        }
        else {
            setValeur(null);
            setInputValue('');
        }
    }, [value, agences]);


    return (
        <Autocomplete
            disablePortal
            loading={loading}
            value={valeur}
            onChange={(event, newValue) => {
                onChange(event, newValue ? newValue.code : null, newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue, reason) => {
                if (reason !== 'reset') {
                    setInputValue(newInputValue);
                }
            }}
            options={agences}
            renderInput={(params) =>
                <TextField
                    {...params}
                    InputLabelProps={{
                        shrink: true
                    }}
                    label={label}
                    required={required}
                    autoFocus={autoFocus}
                    placeholder={placeholder}
                    size={size}
                />}
            getOptionLabel={(option) => option.code + ' - ' + option.libelle}
            isOptionEqualToValue={(option, value) => value ? option.code === value : false}
            blurOnSelect

            />        
    );
}




AgenceAutocomplete.propTypes = {
    required: PropTypes.bool.isRequired,
    autoFocus: PropTypes.bool.isRequired,
    modeTri: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    size: PropTypes.string,
};

AgenceAutocomplete.defaultProps = {
    label:'Agence',
    placeholder:'Rechercher une agence',
    required:false,
    autoFocus:false,
    modeTri:0,
};

export default AgenceAutocomplete;